module.exports = __webpack_public_path__ + "static/media/bus.22f3354e.png";